import { Component, signal, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

const STORAGE_KEY = 'tfr_cookie_consent';

@Component({
  selector: 'app-cookie-consent',
  imports: [RouterLink],
  templateUrl: './cookie-consent.component.html',
})
export class CookieConsentComponent implements OnInit {
  visible = signal(false);

  ngOnInit(): void {
    if (!localStorage.getItem(STORAGE_KEY)) {
      // Slight delay so the page renders first
      setTimeout(() => this.visible.set(true), 800);
    }
  }

  accept(): void {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    this.visible.set(false);
  }

  reject(): void {
    localStorage.setItem(STORAGE_KEY, 'rejected');
    this.visible.set(false);
  }
}
